import { formatTicketDate, paymentLabel, shortTicketId, slaStatusLabel, stageLabel, typeLabel } from './serviceTicketLabels';

export function mapServiceTicketRows(page, t) {
  const list = page?.content || (Array.isArray(page) ? page : []);
  return list.map((ticket) => ({
    id: ticket.id,
    shortId: shortTicketId(ticket.id),
    type: ticket.type,
    typeLabel: typeLabel(t, ticket.type),
    stage: ticket.stage,
    stageLabel: stageLabel(t, ticket.stage),
    stationNumber: ticket.stationNumber || '—',
    venueName: ticket.venueName || ticket.address || '—',
    equipmentSerial: ticket.stationId || ticket.stationID || '—',
    assigneeEmail: ticket.assigneeEmail || '—',
    ownerAdminEmail: ticket.ownerAdminEmail || '—',
    networkType: ticket.networkType || ticket.operator || '—',
    paymentStatus: ticket.paymentStatus,
    paymentLabel: paymentLabel(t, ticket.paymentStatus),
    overdue: Boolean(ticket.overdue),
    slaDueAt: ticket.slaDueAt,
    slaDueLabel: formatTicketDate(ticket.slaDueAt),
    slaStatusLabel: slaStatusLabel(t, ticket),
    createdAt: ticket.createdAt,
    createdAtLabel: formatTicketDate(ticket.createdAt),
    slaPenaltyAmount: ticket.slaPenaltyAmount,
    _raw: ticket,
  }));
}
